import { Component, OnInit } from '@angular/core';
import { HomeComponent } from '../home/home.component';

@Component({
    selector: 'eol-home',
    templateUrl: './eol-home.component.html'
})
export class EolHomeComponent extends HomeComponent implements OnInit {
    readonly dtcUrl = 'https://havenlife.com/online-term-life-insurance?utm_source=mmdirect&utm_medium=redirect';

    ngOnInit(): void {
        super.ngOnInit();
    }

    login() {
        this.router.navigate(['login']);
    }
}
